import { commonHelpers } from 'utilities/helpers';
import { RateBadge } from '../../CU-002-01/components/Rate';
import { ListedPropertyRoomGetAssessmentDetail } from '../models/Property';

interface props {
    detailAssessment?: ListedPropertyRoomGetAssessmentDetail;
}

export const MarketPrice = ({ detailAssessment }: props) => {
    return (
        <section>
            <div
                className="center-inside"
                style={{ height: 24, width: 'fit-content', marginTop: 16 }}
            >
                <section className="mkp-label">相場価格</section>
                <section style={{ textAlign: 'right', marginRight: 8 }}>
                    <span className="mkp-number">
                        {(detailAssessment?.marketPrice
                            ? commonHelpers.roundTenThousandYen(detailAssessment?.marketPrice)
                            : 0
                        ).toLocaleString('en-US', {
                            maximumFractionDigits: 2,
                        })}
                    </span>
                    <span className="mkp-unit"> 万円</span>
                </section>
                <RateBadge
                    value={detailAssessment?.priceAssumed ? detailAssessment?.priceAssumed : 0}
                />
            </div>
        </section>
    );
};
